import Vue from 'vue'
import store from '../../../store'
import dialogConfig from '../../../config/dialog/index'

class DialogInstance {
    constructor(config ) {
        this.name = config.name
        this.title = config.title
        this.width = config.width || '50%'
        this.component = config.component
        this.buttons = config.buttons
        this.active = true
    }

    afterClose(callback){
        if(this.active){
            this.callback = callback
        }else{
            if(this.callback && typeof(this.callback) === "function") {
                this.callback()
            }

            let newStack = []
            store.state.dialogStack.forEach((item) => {
                if(item.name != this.name){
                    newStack.push(item)
                }
            })
            store.commit('resetDialogStack', newStack)
        }
    }
}

class DialogManager {
    constructor() {
        Object.keys(dialogConfig).forEach(item => {
            this[item] = function() {
                let config = dialogConfig[item]
                const dialog = new DialogInstance(config)
                store.commit('dialogStackPush', dialog)
                return dialog
            }
        })
    }

    close(name) {
        store.state.dialogStack.forEach((item) => {
            if(item.name === name){
                item.active = false
            }
        })
    }
}

Vue.prototype.$dialog = new DialogManager()
